<template>
  <div class="legal-page">
    <div class="card">
      <header class="page-header">
        <h1 class="h1">
          Impressum
        </h1>
      </header>

      <section>
        <p class="impressum-intro">
          Angaben gemäß § 5 Telemediengesetz (TMG) und § 18 Abs. 2 Medienstaatsvertrag (MStV).<br>
          Dieses Impressum gilt für das unter dieser Adresse bereitgestellte Online-Portal der
          <strong>Freien Naturschule Barnim</strong>.
        </p>

        <h3>Diensteanbieter / Schulträger</h3>
        <p>
          <strong>wild frei grün e.V.</strong><br>
          Bahnhofstraße 81a<br>
          16359 Biesenthal<br>
          Deutschland
        </p>
        <p>
          Vertreten durch den Vorstand:<br>
          Monique Reiter, Doreen Buske, Andreas Nick
        </p>
        <p>
          E-Mail: <a href="mailto:kontakt@wildfreigruen.de">kontakt@wildfreigruen.de</a><br>
          Steuernummer: 065/142/07125<br>
          Zuständiges Finanzamt: Finanzamt Eberswalde
        </p>

        <h3>Schule / Einrichtung</h3>
        <p>
          <strong>Freie Naturschule Barnim</strong><br>
          Schulleitung: Anja Wetzel<br>
          Bahnhofstraße 81a<br>
          16359 Biesenthal
        </p>
        <p>
          Telefon: <a href="tel:+491794297799">+49 (0) 179 429 77 99</a><br>
          E-Mail: <a href="mailto:kontakt@naturschule-barnim.de">kontakt@naturschule-barnim.de</a>
        </p>

        <h3>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h3>
        <p>
          der Vorstand (siehe oben)
        </p>
        <p>
          E-Mail: <a href="mailto:kontakt@naturschule-barnim.de">kontakt@naturschule-barnim.de</a>
        </p>

        <h3>Zweck des Online-Portals</h3>
        <p>
          Dieses Online-Portal dient der digitalen Kommunikation und Organisation im Zusammenhang mit der
          Freien Naturschule Barnim, insbesondere der Bereitstellung von Informations- und Verwaltungsfunktionen
          für berechtigte Nutzerinnen und Nutzer (z.&nbsp;B. Eltern, Mitarbeitende, Schülerinnen und Schüler).
          Der inhaltlich zugängliche Bereich ist überwiegend nur für angemeldete bzw. registrierte Nutzer bestimmt.
          Auf der öffentlich erreichbaren Login-Seite werden ausschließlich technische Informationen zur Nutzung des
          Portals bereitgestellt.
        </p>

        <h3>Urheberrecht</h3>
        <p>
          Die Inhalte und die Gestaltung dieses Online-Portals, insbesondere Texte, Struktur, Layout und ggf. verwendete
          Grafiken, unterliegen dem deutschen Urheberrecht und ggf. weiteren Schutzrechten.
          Soweit nicht anders angegeben, liegen die Nutzungsrechte beim
          <strong>wild frei grün e.V.</strong> bzw. der <strong>Freien Naturschule Barnim</strong>
          oder bei ausdrücklich benannten Rechteinhabern.
        </p>
        <p>
          Inhalte dürfen von Nutzerinnen und Nutzern ausschließlich für den bestimmungsgemäßen Gebrauch innerhalb
          des Schul- bzw. Einrichtungsbetriebs sowie zum privaten Gebrauch im Rahmen des §&nbsp;53
          Urheberrechtsgesetz (UrhG) verwendet werden.
          Eine darüber hinausgehende Vervielfältigung, Bearbeitung, Verbreitung oder öffentliche Wiedergabe –
          insbesondere über das Internet, soziale Medien oder andere Plattformen – bedarf der vorherigen schriftlichen
          Zustimmung der jeweiligen Rechteinhaber.
        </p>
        <p>
          Soweit Inhalte (z.&nbsp;B. Texte, Materialien, ggf. Grafiken) von Dritten bereitgestellt werden, sind diese
          als solche kenntlich gemacht. Die Nutzung dieser Inhalte ist nur im Rahmen der jeweils angegebenen
          Nutzungsrechte zulässig. Ohne ausdrückliche Zustimmung der Rechteinhaber ist eine weitere Verwertung
          unzulässig.
        </p>

        <h3>Haftung für Inhalte</h3>
        <p>
          Die Inhalte dieses Online-Portals wurden mit größter Sorgfalt erstellt. Es wird dennoch keine Gewähr für die
          Richtigkeit, Vollständigkeit, Aktualität und jederzeitige Verfügbarkeit der bereitgestellten Informationen
          übernommen.
        </p>
        <p>
          Als Diensteanbieter sind wir gemäß §&nbsp;7 Abs.&nbsp;1 TMG für eigene Inhalte auf diesen Seiten
          nach den allgemeinen Gesetzen verantwortlich. Nach §§&nbsp;8 bis&nbsp;10 TMG sind wir jedoch nicht
          verpflichtet,
          übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen,
          die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen
          bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
          konkreten Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen werden wir diese
          Inhalte umgehend entfernen.
        </p>

        <h3>Haftung für Links</h3>
        <p>
          Soweit in diesem Portal Links oder technische Verweise auf Internetseiten Dritter enthalten sind, stellen
          diese
          Links lediglich einen Zugang zu Inhalten Dritter dar und bedeuten keine Billigung oder Übernahme dieser
          Inhalte.
          Für die Inhalte der verlinkten Seiten ist ausschließlich der jeweilige Anbieter oder Betreiber verantwortlich.
        </p>
        <p>
          Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung nach bestem Wissen auf mögliche Rechtsverstöße
          überprüft; rechtswidrige Inhalte waren zu diesem Zeitpunkt nicht erkennbar.
          Eine dauerhafte inhaltliche Kontrolle der verlinkten Seiten ist ohne konkrete Anhaltspunkte einer
          Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden derartige Links
          umgehend entfernt.
        </p>

        <h3>Außergerichtliche Streitbeilegung / Verbraucherschlichtung</h3>
        <p>
          Wir sind weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
          im Sinne des Verbraucherstreitbeilegungsgesetzes (VSBG) teilzunehmen.
        </p>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS-Plattform) bereit, die
          unter <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ec.europa.eu/consumers/odr</a> erreichbar ist.
          Unser Online-Portal richtet sich überwiegend an Angehörige der Freien Naturschule Barnim (Schülerinnen und
          Schüler,
          Eltern, Mitarbeitende) und ist nicht als Online-Shop oder Vertragsportal für Verbraucher im klassischen Sinne
          ausgestaltet.
        </p>
      </section>
    </div>
    <PublicLegalFooter />
  </div>
</template>

<script setup>
import PublicLegalFooter from '@/components/layout/PublicLegalFooter.vue';
// statische Seite
</script>

<style scoped>
.legal-page {
  padding: 16px;
  background: var(--bg, #F6F7F9);
  color: var(--text, #1F2937);
  min-height: 100vh;
}

.page-header {
  border-bottom: 1px solid var(--border, #E0E3EA);
  padding-bottom: 8px;
  margin-bottom: 12px;
}

.h1 {
  font-size: 26px;
  line-height: 34px;
  font-weight: 600;
  margin: 0;
}

.mt-12 {
  margin-top: 12px;
}

.card {
  background: var(--surface, #FFFFFF);
  border: 1px solid var(--border, #E0E3EA);
  border-radius: 10px;
  padding: 16px;
  max-width: 840px;
}

.legal-page .card {
  max-width: none
}

a {
  color: var(--primary, #4F46E5);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>